<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <g clip-path="url(#clip0_376_38056)">
        <path d="M9.51768 2.26025H0.482358C0.0547941 2.26025 -0.163022 2.77656 0.143534 3.08311L4.66119 7.60077C4.84674 7.78632 5.15329 7.78632 5.33892 7.60077L9.85658 3.08311C10.1631 2.77656 9.94524 2.26025 9.51768 2.26025Z" fill="#69B518"/>
    </g>
    <defs>
        <clipPath id="clip0_376_38056">
            <rect width="10.0001" height="10" fill="white"/>
        </clipPath>
    </defs>
</svg>